export var RateProviderType;
(function (RateProviderType) {
    RateProviderType["RATE_LIST"] = "rate-list";
    RateProviderType["RATE_FUNCTION"] = "rate-function";
})(RateProviderType || (RateProviderType = {}));
